import React from 'react';
import { Button, Space } from 'antd';
import { PlusOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';

const ProposalActions = ({
  onAddItem,
  onCancel,
  onSubmit,
  loading,
  isEdit,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
        marginTop: 8,
      }}
    >
      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={onAddItem}
        data-testid="add-item-btn"
      >
        Add Item
      </Button>

      <Space>
        {onCancel && (
          <Button
            icon={<CloseOutlined />}
            onClick={onCancel}
            disabled={loading}
            data-testid="cancel-btn"
          >
            Cancel
          </Button>
        )}
        <Button
          type="primary"
          htmlType="submit"
          icon={<SaveOutlined />}
          loading={loading}
          data-testid="submit-btn"
        >
          {isEdit ? 'Update Proposal' : 'Save Proposal'}
        </Button>
      </Space>
    </div>
  );
};

export default ProposalActions;
